module.exports = __webpack_public_path__ + "img/Pic_XXFW_JX.981b79bb.png";